import BCookie from "../../utils/BCookie";

let state = {
	accessToken: (BCookie.check("BCAccessToken") ? BCookie.get("BCAccessToken") : null),
	forgot_email: ""
};

export default state
